import { Cross1Icon } from '@radix-ui/react-icons';

import { Badge } from '../../primitives/badge';
import { cn } from '../../utils/cn';

import type { JSX } from 'react';

interface BadgeWithButtonProps extends React.ComponentPropsWithoutRef<typeof Badge> {
  disabled?: boolean;
  label: string | JSX.Element;
  onCallback: VoidFunction;
}

export function BadgeWithButton({
  disabled = false,
  label,
  onCallback,
  ...props
}: BadgeWithButtonProps) {
  return (
    <div className="relative">
      <div
        className={cn(
          'absolute top-[-0.5rem] right-[-0.5rem] z-10 m-0 flex size-6 cursor-pointer items-center justify-center rounded-full border bg-background p-0',
          { 'cursor-not-allowed': disabled },
        )}
        onClick={(event) => {
          event.preventDefault();
          if (disabled) return;

          onCallback();
        }}
      >
        <Cross1Icon className="size-3 max-h-3 max-w-3" />
      </div>
      <Badge className="gap-2" {...props}>
        {label}
      </Badge>
    </div>
  );
}
